import styled from 'styled-components';
import { MetricWidgetBase } from '@components/overview-dashboard/common/mixins';
import breakpoint from 'styled-components-breakpoint';
import BaseTable from 'react-base-table';

export const MetricWidgetWrapperSub = styled.div`
  ${MetricWidgetBase};
  padding-left: 0;
  padding-right: 0;

  ${breakpoint('tablet')`
        width: 100%;
    `};

  ${breakpoint('desktop')`
        width: 32%;
        height: 400px;
    `};

  ${breakpoint('mobile')`
        width: 100%;
    `};
`;

export const SubOpportunitiesWrapper = styled.div`
  width: 25%;
  height: 100%;
  display: flex;
  flex-flow: column wrap;
  background-color: #fff;
  min-width: 300px;
  margin-bottom: 5px;
  padding: 10px;
  box-sizing: border-box;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding-top: 10px;
`;

export const MetricCardWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  ${breakpoint('desktop')`
      height: 55px;
  `};
  ${breakpoint('mobile')`
      height: auto;
  `};
  align-items: center;
  border: 2px solid transparent;
  border-radius: 2px;
  cursor: pointer;
  background-color: ${({ selected }: { selected: any }) => (selected ? '#E9F3FD' : '#ffffff')};

  &:hover {
    background: #e9f3fd;
  }

  &:active {
    background: #e9f3fd;
  }

  padding: 0 3px;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
`;

export const MetricNameWrapper = styled.div`
  width: 34%;
  flex-grow: 1;
  font-weight: 300;
  font-size: 16px;
  line-height: 25px;
`;

export const MetricValueWrapper = styled.div`
  flex-grow: 1;
  font-size: 16px;
  line-height: 25px;
  width: 15%;
  display: flex;
`;

export const MetricValue = styled.div`
  font-weight: 500;
`;

export const MetricUnitWrapper = styled.div`
  font-weight: 300;
`;

export const MetricChartWrapper = styled.div`
  flex-grow: 3;
  margin-bottom: 2px;
  align-items: center;
  padding: 2px 1px;
  padding-right: 10px;
  ${breakpoint('desktop')`
      width: 49%;
  `};
  ${breakpoint('tablet')`
      width: 49%;
  `};
  ${breakpoint('mobile')`
     width: 100%;
  `};
`;

export const OpportunityText = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 27px;
  color: #4a4a4a;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 5px 10px;
`;

export const ModalWrapper = styled.div`
  position: absolute;
  top: 7px;
  right: 7px;
  max-width: 80%;
  min-width: 300px;
  z-index: 17;
`;

export const KPIContentWrapper = styled.div`
  position: absolute;
  padding: 5px;
  height: 300px;
  max-height: 500px;
  overflow-y: auto;
`;

export const StyledParaHeader = styled.div`
  font-size: 13px;
  font-weight: 400 !important;
`;

export const StyledPara = styled.p`
  font-size: 13px;
  font-weight: 100;
  text-align: left;
`;

export const StyledListWrapper = styled.div`
  padding-left: 15px;
`;
export const StyledListItem = styled.li`
  font-size: 13px;
  font-weight: 100;
  text-align: left;
`;

export const ToggleWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
`;

export const AdContentTableWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  font-weight: 300;
  font-size: 1.1em;
  padding: 10px;
`;

export const StyledBaseTable = styled(BaseTable)`
  font-size: 16px;
  border: none;
  box-shadow: none;

  .BaseTable__table-main {
    outline: none;
  }

  .BaseTable__row {
    font-size: 16px;
    font-weight: lighter;

    &:hover {
      background-color: #e9f3fd;
    }
  }

  .selected {
    background-color: #e9f3fd;
    cursor: pointer;
  }

  .not-selected {
    cursor: pointer;
  }

  .BaseTable__header-row {
    outline: none;
    font-weight: 400;
    font-size: 14px;
    background-color: #fff;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-flow: row nowrap;
  height: 30px;
  place-content: center space-around;
  align-items: center;
  text-align: center;

  > div {
    cursor: pointer;
    border-radius: 3px;

    &.selected {
      background-color: #e9f3fd;

      svg#DistributionIcon path {
        fill: #2494ff;
      }

      svg#TimeseriesIcon path {
        stroke: #2494ff;
      }

      svg#BenchmarkIcon path {
        fill: #2494ff;
      }
    }
  }
`;

export const IconWrap = styled.div`
  font-size: 1.4em;
  display: inline-block;
  width: 40px;
  height: 25px;
`;

export const BoldTextWrap = styled.span`
  font-weight: 600;
`;

export const LightTextWrap = styled.span`
  font-weight: 300;
  color: #9e9e9e;
  font-size: 0.9em;
`;
export const StartupTableWrapper = styled.div`
  margin-top: 165px;
  height: 150px;
`;
